import axios from "axios";

export function fetchActiveMessengersLocationsAction(bid) {
    return {
        type: "FETCH_ACTIVE_MESSENGERS_LOCATION",
        payload: async () => {
            const response = await axios.get('/api/v2a/getActiveMessengersLocations', {
                params: {bid}
            });

            return response.data;
        }
    };
}
